import { render, staticRenderFns } from "./SelectAvailableTemplate.vue?vue&type=template&id=3889d1e1&"
import script from "./SelectAvailableTemplate.vue?vue&type=script&lang=ts&"
export * from "./SelectAvailableTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports